/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Not_CandidateInputs */

const vi_carrier_legacy_not_candidate = /** @type {(inputs: Carrier_Legacy_Not_CandidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ vừa đổi, chọn lại xã in trên tem`)
};

/**

* @param {Carrier_Legacy_Not_CandidateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_not_candidate = /** @type {((inputs?: Carrier_Legacy_Not_CandidateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Not_CandidateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_not_candidate(inputs)
});